<template>
  <div>
    <!-- <div class="left">
      <span class="checkbox small">
        <input type="checkbox" id="check_editmode" v-model="editMode" @change="checkEditMode(editMode)">
        <label for="check_editmode">{{locale.mode_edit}}</label>
      </span>
      <span v-if="$route.path.includes('/page/item')" class="checkbox small">
        <input type="checkbox" id="check_widemode" v-model="wideMode" @change="checkWideMode(wideMode)">
        <label for="check_widemode">{{locale.mode_wide}}</label>
      </span>
    </div> -->
    <div class="right">
      <div class="account" :class="account && account.userRole">
        <router-link to="/account" class="nickname">
          <span class="icoUserRole" :data-role="account && account.userRole"></span>
          {{(account && account.sgnickname) || '-'}} <span class="colorGrey">({{(account && account.sgusername) || '-'}})</span>
        </router-link>
      </div>
      <a
        :href="previewHref"
        target="_blank"
        class="btn sizeXs"
        @click="onPreviewClick">
        {{ locale.preview }}
      </a>
      <button type="button" class="btn btnGrey sizeXs" @click="logout">{{locale.logout}}</button>
      <!-- <div class="publicCastit">
        <a :href="manualLink" target="_blank">MANUAL</a>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Header',
  props: [
    'locale'
  ],
  computed: {
    ...mapGetters({
      userInfo: 'authentication/getUserInfo',
      authInfo: 'authentication/getAuthInfo'
    }),
    serviceLocale () {
      return this.$store.state.service.locale.default
    },
    manualLink () {
      const partner = this.$store.state.service.partner
      const serviceLocale = this.serviceLocale
      const manual = function () {
        const data = {}
        if (partner === 'NSJ') {
          data.site = 'cmj'
          data.link = 'coreguide.jp'
        } else {
          data.site = 'bdf'
          data.link = 'castit.ai'
        }
        return data
      }
      return `/viewer/index.html?site=${manual().site}#/${serviceLocale}`
    },
    lang () {
      const settingData = this.$store.getters['setting/getData']
      return settingData.lang
    },
    previewHref () {
      return this.buildPreviewHref({ altShopPrefix: false })
    }
  },
  created () {
    this.$store.dispatch('authentication/getMyAccount').then((res) => {
      if (res) {
        if (res.message && typeof (res.message) === 'string' && res.message.includes('not authorized')) {
          this.logout()
        } else {
          this.account = res.message
        }
      } else {
        this.logout()
      }
    })
  },
  data () {
    return {
      editMode: false,
      wideMode: false,
      myinfo: false,
      account: null
    }
  },
  methods: {
    onPreviewClick (e) {
      const isCtrlorMeta = e.ctrlKey || e.metaKey
      if (!isCtrlorMeta) return // 기본 동작(현재 href로 새 탭)

      // ctrl/cmd 클릭일 때만 shopPage 대체 링크로 새 탭 오픈
      // (target=_blank 이라 그냥 href 바꿔치기보다 명시적으로 여는 게 안전)
      const url = this.buildPreviewHref({ altShopPrefix: true })
      if (!url) return

      e.preventDefault()
      window.open(url, '_blank', 'noopener')
    },
    buildPreviewHref ({ altShopPrefix } = {}) {
      const site = this.userInfo?.siteid
      const lang = this.lang?.default || 'ko'
      if (!site) return ''

      const name = this.$route?.name
      const params = this.$route?.params || {}

      // builders가 path + (base)query를 같이 리턴하도록
      const builders = {
        pageItem: (p) => ({
          path: `page/${p.id}`,
          ...altShopPrefix && {baseQuery: { frame: 'false' }}
        }),

        shopPage: (p) => ({
          path: `${altShopPrefix ? 'store' : 'shop'}/${p.id}/${p.categoryId}`
        }),

        productItem: (p) => ({
          path: `product/${p.id}`,
          ...altShopPrefix && {baseQuery: { frame: 'false' }}
        }),

        reservationItem: (p) => ({
          path: `reservation/${p.id}`,
          ...altShopPrefix && {baseQuery: { frame: 'false' }}
        }),

        collectionPage: (p) => ({
          path: `collection/${p.pageId}`,
          baseQuery: { frame: 'false' } // 해시# 앞에 붙일 쿼리
        }),

        tv: () => ({
          path: 'tv',
          ...altShopPrefix && {baseQuery: { frame: 'false' }}
        }),
        amenity: () => ({
          path: 'amenity',
          ...altShopPrefix && {baseQuery: { frame: 'false' }}
        })
      }

      const build = builders[name]
      const built = build ? build(params) : null
      if (!built?.path) {
        // 매핑 없으면 base만
        return `/viewer/index.html?site=${encodeURIComponent(site)}`
      }

      const baseParams = new URLSearchParams({ site: String(site) })
      if (built.baseQuery) {
        Object.entries(built.baseQuery).forEach(([k, v]) => baseParams.set(k, String(v)))
      }
      const base = `/viewer/index.html?${baseParams.toString()}`

      const hashPath = built.path
        .split('/')
        .map(encodeURIComponent)
        .join('/')

      return `${base}#/${encodeURIComponent(lang)}/${hashPath}`
    },
    checkEditMode (isEditMode) {
      const toggle = isEditMode ? 'add' : 'remove'
      document.body.classList[toggle]('editMode')
    },
    checkWideMode (wideMode) {
      const toggle = wideMode ? 'add' : 'remove'
      document.body.classList[toggle]('wideMode')
    },
    logout () {
      this.$emit('logout')
    }
  }
}
</script>

<style lang="scss" scoped>
.left {
  margin-right: auto;
}
.right {
  margin-left: auto;
  .btn {
    margin-left: 2.4em;
    &+.btn {
      margin-left: 1em;
    }
  }
}
.account {
  display: inline-block;
  position: relative;
  .nickname {
    display: inline-block;
    padding-left: calc(20px + 0.3em);
   cursor: pointer;
  }
  .icoUserRole {
    position: absolute;
    top: 50%;
    left: 0;
    width: 20px;
    height: 20px;
    margin-top: -10px;
    border-radius: 100%;
    background-size: 80%;
    box-shadow: 0 0 0 1px rgba(0,0,0,0.15);
  }
}

.publicCastit {
  display: inline-block;
  margin-left: 45px;
  vertical-align: middle;
  a {
    display: block;
    position: relative;
    height: 60px;
    padding: 0 15px 0 40px;
    color: $color-white;
    line-height: 60px;
    @include gradient($color-blue, $color-red, 45deg);
    &:before {
      content: "i";
      position: absolute;
      top: 50%;
      left: 15px;
      width: 14px;
      height: 14px;
      margin-top: -8px;
      text-align: center;
      font-size: 12px;
      font-weight: 700;
      line-height: 14px;
      border-radius: 100%;
      border: 1px solid $color-white;
      vertical-align: middle;
    }
  }
}
</style>
